module.exports = __webpack_public_path__ + "static/media/exams-profile.3c6a87ee.svg";